import { useCallback, useReducer } from 'react'
import { isValidPhoneNumber } from 'react-phone-number-input'

import { apiManager } from 'helpers'

const initState = {
  loading: false,
  error: null,
}
const START_VERIFICATION = 'START_VERIFICATION'
const END_VERIFICATION = 'END_VERIFICATION'
const VERIFICATION_ERROR = 'VERIFICATION_ERROR'
const CLEAN_ERROR = 'CLEAN_ERROR'
const reducer = (state, action) => {
  switch (action.type) {
    case START_VERIFICATION:
      return { ...state, loading: true, error: null }
    case END_VERIFICATION:
      return { ...state, loading: false, error: null }
    case VERIFICATION_ERROR:
      return { ...state, loading: false, error: action.payload }
    case CLEAN_ERROR:
      return { ...state, error: null }
    default:
      throw new Error()
  }
}

const useVerifyPhoneNumber = () => {
  const [state, dispatch] = useReducer(reducer, initState)

  const verify = useCallback(async phoneNumber => {
    try {
      dispatch({ type: START_VERIFICATION })
      if (!phoneNumber || !isValidPhoneNumber(phoneNumber)) {
        throw new Error('Invalid phone number, try again!')
      }
      await apiManager.verifyPhoneNumber(phoneNumber)
      dispatch({ type: END_VERIFICATION })
      return true
    } catch (err) {
      dispatch({ type: VERIFICATION_ERROR, payload: err.message })
      return false
    }
  }, [])
  const cleanError = useCallback(() => dispatch({ type: CLEAN_ERROR }), [])

  return { verify, cleanError, ...state }
}

export default useVerifyPhoneNumber
